import Vue from 'vue';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
Vue.prototype.$moment = moment;
window.$projectName = 'dataImage';
import { ConfigProvider, Icon,
// Row,
// Col,
Button,
Modal,
// Form,
// FormModel,
Input,
// Tabs,
// Tree,
// Tooltip,
// Card,
// Table,
// Dropdown,
// Menu,
// Popover,
// Pagination,
// Radio,
Select,
// DatePicker,
// Checkbox,
// Empty,
// Spin,
// TreeSelect,
// Timeline,
// Cascader,
// Switch,
// AutoComplete,
Message
// Tabs
} from 'thsc-ifind-antdv';
Vue.use(ConfigProvider);
Vue.use(Icon);
// Vue.use(Row);
// Vue.use(Col);
Vue.use(Button);
Vue.use(Modal);
// Vue.use(Form);
// Vue.use(FormModel);
Vue.use(Input);
// Vue.use(Tabs);
// Vue.use(Tree);
// Vue.use(Tooltip);
//  Vue.use(Card);
// Vue.use(Table);
// Vue.use(Dropdown);
// Vue.use(Menu);
// Vue.use(Popover);
// Vue.use(Pagination);
// Vue.use(Radio);
Vue.use(Select);
// Vue.use(DatePicker);
// Vue.use(Checkbox);
// Vue.use(Empty);
// Vue.use(Spin);
// Vue.use(TreeSelect);
// Vue.use(Timeline);
// Vue.use(Cascader);
// Vue.use(Switch);
// Vue.use(AutoComplete);
// Vue.use(Tabs)

Vue.prototype.$message = Message;